export const Countries = [
  {"name": "Canada", "abbreviation": "CAN"},
  {"name": "Mexico", "abbreviation": "MEX"},
  {"name": "United States", "abbreviation": "USA"}
];
